import { Typ20 } from '../Typ';
import styled from 'styled-components';

export const Button = styled.button`
  background-color: #78909c;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  border: 0;
`;

export const Number = styled(Typ20)`
  color: #ffffff;
`;
